import { forwardRef } from 'react';

import { useGetVirtualSpaceQuery } from '@spazious/dollhouse-graphql/apollo';
import { useGraph } from '@spazious/dollhouse-store';
import { styled } from '@spazious/dollhouse-theme';
import { Flex, FlexElement, FlexProps, Typography } from '@spazious/dollhouse-uikit';

export type SetupNameElement = FlexElement;
export interface SetupNameProps extends FlexProps {}

export const SetupName = styled(
  forwardRef<SetupNameElement, SetupNameProps>((props, ref) => {
    const spaceId = useGraph().graph.shallow.space;
    const { data, loading } = useGetVirtualSpaceQuery({
      skip: !spaceId,
      variables: {
        id: `${spaceId}`,
      },
    });
    const { graph } = useGraph();

    return (
      <Flex ref={ref} {...props}>
        <Typography size="small" variant="label">
          {loading
            ? 'loading'
            : [data?.virtualSpace.hotel, data?.virtualSpace.name, graph.shallow.name]
                .filter(Boolean)
                .join(' - ')}
        </Typography>
      </Flex>
    );
  })
).withConfig({
  displayName: 'SetupGraphName',
})``;
